import { useTranslation } from 'react-i18next';
import { Dialog } from '@/common/components/Dialog/Dialog';
import { Icon } from '@/common/components/Icons/Icon';
import { Translate } from '@/common/components/Translate/Translate';
import { MARKET } from '@/common/constants/markets';
import { useMarket } from '@/common/hooks/useMarket';

export type TInsuranceRemovalModalProps = {
  onClose: () => void;
  onConfirm: () => void;
};

export const InsuranceRemovalModal = ({
  onClose,
  onConfirm,
}: TInsuranceRemovalModalProps) => {
  const { t } = useTranslation();
  const { slug } = useMarket();
  return (
    <Dialog
      icon={<Icon icon="shield-slash" />}
      iconBadgeColor="accentSecondary20"
      title={t('dashboard.insurance_detail.remove_modal.title')}
      message={
        slug === MARKET.ES ? (
          <Translate i18nKey="dashboard.insurance_detail.remove_modal.description.es" />
        ) : (
          <Translate i18nKey="dashboard.insurance_detail.remove_modal.description" />
        )
      }
      primaryAction={{
        children: t('dashboard.insurance_detail.remove_modal.action_label'),
        onPress: (closeModal) => {
          onConfirm();
          closeModal();
        },
      }}
      secondaryAction={{
        children: t('general.navigation.cancel'),
      }}
      onClose={onClose}
    />
  );
};
